import React from "react";

const AboutUsDescription = () => {
  return (
    <section className="my-5">
      <div className="container py-3 text-dark">
        <div className="row">
          <div className="col-md-12">
            <p className="text-justify" style={{ textAlign: "justify" }}>
              TZ Creation is a product design and frontend engineering studio
              built around one idea: senior talent should be easy to bring
              onto a team, not locked behind a long hiring process or a
              black-box agency engagement. We work as an extension of product
              teams — primarily in healthcare, edtech, and HR tech — taking on
              staff augmentation and dedicated-team engagements alongside
              scoped project work for teams that need a website, brand
              identity, or app built end to end. Every placement and every
              project is backed by real, shipped work: products, screens, and
              systems already live in production, not portfolio mockups.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsDescription;
